import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { INumberSlice, TNumberAreaCode } from "@/redux/slices/numbers/types";

export const getAreaCodes = createAsyncThunk(
  "numbers/getAreaCodes",
  async (countryValue: string) =>
    await axios({
      method: "GET",
      url: `/svc/area-codes/${countryValue}/dashboard-names`,
    }).then((res) => res.data?.result)
);

const fulfilled = (
  state: INumberSlice,
  { payload, meta }: { payload: TNumberAreaCode[]; meta: { arg: string } }
) => {
  const country = state.countries.find((country) => country.value === meta.arg);
  if (country) {
    country.area_codes = payload;
  }
};

export default {
  action: getAreaCodes,
  fulfilled,
};
